import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, CccisdFieldWrapper } from 'cccisd-formik';
import { MultiSelect } from 'react-multi-select-component';
import style from './style.css';

const InterventionsSelect = props => {
    const [interventionList, setInterventionList] = useState([]);
    const reduxStore = useSelector(state => state.app.egto);

    useEffect(() => {
        if (reduxStore.step5ReportDataLoaded && reduxStore.step5InterventionList[0].value !== '') {
            setInterventionList(
                reduxStore.step5InterventionList.map((option, index) => {
                    return {
                        ...option,
                        disabled: index >= 3,
                    };
                })
            );
        }
    }, [reduxStore.step5ReportDataLoaded, reduxStore.step5InterventionList]);

    const maxOptions = 3;

    const handleOnChange = (value, form) => {
        form.setFieldValue('intervention', value);
        const newOptions = [];
        if (value.length === maxOptions) {
            interventionList.forEach(option => {
                newOptions.push({
                    ...option,
                    disabled: !value.map(i => i.label).includes(option.label),
                });
            });
            setInterventionList(newOptions);
        } else {
            setInterventionList(reduxStore.step5InterventionList);
        }
    };

    if (!reduxStore.step5ReportDataLoaded && reduxStore.step5InterventionList[0].value === '') {
        return <div />;
    }

    return (
        // Margin is needed when report is displayed in flow player.
        <div style={{ marginBottom: '1em' }}>
            <Field name="intervention" label="Intervention" enableReinitialize>
                {({ field, form }) => {
                    return (
                        <CccisdFieldWrapper field={field} form={form} label="Intervention">
                            <MultiSelect
                                options={interventionList}
                                hasSelectAll={false}
                                disableSearch
                                value={
                                    form.values.intervention
                                        ? form.values.intervention
                                        : reduxStore.step5InterventionList
                                }
                                onChange={value => handleOnChange(value, form)}
                                labelledBy="intervention"
                                className={style.fixedWidth}
                                ClearSelectedIcon={<div />}
                            />
                        </CccisdFieldWrapper>
                    );
                }}
            </Field>
        </div>
    );
};

InterventionsSelect.propTypes = {
    settings: PropTypes.object,
};

export default InterventionsSelect;
